// src/context/ThemeContext.js
// Context pour gérer le thème clair/sombre - NE PAS MODIFIER

import React, { createContext, useState, useEffect, useCallback } from 'react';

export const ThemeContext = createContext();

// Palette SOMBRE (par défaut)
const darkTheme = {
  mode: 'dark',
  bg: '#0A0E1A',
  bgCard: '#162033',
  bgInput: '#111827',
  bgElevated: '#1C2537',
  textPrimary: '#FFFFFF',
  textSecondary: '#A0AEC0',
  textMuted: '#4A5568',
  gold: '#FFD700',
  goldSoft: 'rgba(255, 215, 0, 0.15)',
  goldBorder: 'rgba(255, 215, 0, 0.3)',
  border: 'rgba(255, 255, 255, 0.1)',
  borderSoft: 'rgba(255, 255, 255, 0.05)',
  navBg: '#0A0E1A',
  overlay: 'rgba(0, 0, 0, 0.6)',
  shadow: '0 10px 25px rgba(0, 0, 0, 0.5)',
};

// Palette CLAIRE (blanc pur + or foncé, chic et contrasté)
const lightTheme = {
  mode: 'light',
  bg: '#FFFFFF',
  bgCard: '#F7F7F8',
  bgInput: '#F0F0F2',
  bgElevated: '#FFFFFF',
  textPrimary: '#0A0E1A',
  textSecondary: '#5A6472',
  textMuted: '#9AA3AF',
  gold: '#B8860B', // or foncé (dark goldenrod) pour lisibilité sur blanc
  goldSoft: 'rgba(184, 134, 11, 0.12)',
  goldBorder: 'rgba(184, 134, 11, 0.35)',
  border: 'rgba(0, 0, 0, 0.1)',
  borderSoft: 'rgba(0, 0, 0, 0.06)',
  navBg: '#FFFFFF',
  overlay: 'rgba(0, 0, 0, 0.5)',
  shadow: '0 10px 25px rgba(0, 0, 0, 0.15)',
};

export const ThemeProvider = ({ children }) => {
  const [mode, setMode] = useState('dark');

  // Charger le thème sauvegardé au montage
  useEffect(() => {
    const saved = localStorage.getItem('fynho_theme');
    if (saved === 'light' || saved === 'dark') {
      setMode(saved);
    }
  }, []);

  // Appliquer la couleur de fond au body pour éviter les bandes blanches
  useEffect(() => {
    const theme = mode === 'light' ? lightTheme : darkTheme;
    document.body.style.backgroundColor = theme.bg;
    document.body.style.color = theme.textPrimary;
    localStorage.setItem('fynho_theme', mode);
  }, [mode]);

  const toggleTheme = useCallback(() => {
    setMode((prev) => (prev === 'dark' ? 'light' : 'dark'));
  }, []);

  const theme = mode === 'light' ? lightTheme : darkTheme;

  const value = {
    theme,
    mode,
    toggleTheme,
    isDark: mode === 'dark',
    isLight: mode === 'light',
  };

  return (
    <ThemeContext.Provider value={value}>
      {children}
    </ThemeContext.Provider>
  );
};